import React from "react";
import PropTypes from "prop-types";
import { LayersControl, LayerGroup } from "react-leaflet";
import { icons } from "../../utils";
import { SiteMarkers } from "..";

function SiteLayers({ markers }) {
  const {
    secondaryaccess,
    secondarycoalition,
    secondaryequipment,
    secondaryliteracy,
    access,
    coalition,
    equipment,
    literacy,
  } = markers.reduce(
    (acc, curr) => {
      if (curr.type === "secondary") {
        if (curr.metric === "access") {
          acc.secondaryaccess.push(curr);
        }
        if (curr.metric === "coalition") {
          acc.secondarycoalition.push(curr);
        }
        if (curr.metric === "equipment") {
          acc.secondaryequipment.push(curr);
        }
        if (curr.metric === "literacy") {
          acc.secondaryliteracy.push(curr);
        }
      }
      if (curr.type === "primary") {
        if (curr.metric === "access") {
          acc.access.push(curr);
        }
        if (curr.metric === "coalition") {
          acc.coalition.push(curr);
        }
        if (curr.metric === "equipment") {
          acc.equipment.push(curr);
        }
        if (curr.metric === "literacy") {
          acc.literacy.push(curr);
        }
      }

      return acc;
    },
    {
      secondaryaccess: [],
      secondarycoalition: [],
      secondaryequipment: [],
      secondaryliteracy: [],
      access: [],
      coalition: [],
      equipment: [],
      literacy: [],
    },
  );

  return (
    <LayersControl name="metrics" collapsed={false}>
      <LayersControl.Overlay checked name="Access">
        <LayerGroup>
          <SiteMarkers markers={access} icon={icons.accessIcon} />
          <SiteMarkers
            markers={secondaryaccess}
            icon={icons.secondaryIconAccess}
          />
        </LayerGroup>
      </LayersControl.Overlay>
      <LayersControl.Overlay checked name="Coalition">
        <LayerGroup>
          <SiteMarkers markers={coalition} icon={icons.coalitionIcon} />
          <SiteMarkers
            markers={secondarycoalition}
            icon={icons.secondaryIconCoalition}
          />
        </LayerGroup>
      </LayersControl.Overlay>
      <LayersControl.Overlay checked name="Equipment">
        <LayerGroup>
          <SiteMarkers markers={equipment} icon={icons.equipmentIcon} />
          <SiteMarkers
            markers={secondaryequipment}
            icon={icons.secondaryIconEquipment}
          />
        </LayerGroup>
      </LayersControl.Overlay>
      <LayersControl.Overlay checked name="Literacy">
        <LayerGroup>
          <SiteMarkers markers={literacy} icon={icons.literacyIcon} />
          <SiteMarkers
            markers={secondaryliteracy}
            icon={icons.secondaryIconLiteracy}
          />
        </LayerGroup>
      </LayersControl.Overlay>
    </LayersControl>
  );
}

SiteLayers.propTypes = {
  markers: PropTypes.array,
};
SiteLayers.defaultProps = {
  markers: [],
};

export default SiteLayers;
